//
// SectionHeaderLayoutBuilder
//
// Section title with optional tag (used by synthesized extended layouts)

import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../stores'

import { Text } from '../../../../components'
import { ItemTitle } from '../../../components'

export const SectionHeaderLayoutBuilder = observer(function SectionHeaderLayoutBuilder({
    className,
    component,
    components,
    layout,
    record,
    worksheet,
    active_class,
    visited_gids,
    force_readonly,
}) {
    const { app, data } = useStore()

    let classNames = 'ws-section-header'
    if (className) classNames += ' ' + className

    const class_ = component['class']
        ? (worksheet.classes && worksheet.classes.get(component['class'])) ||
          data.classes.get(component['class'])
        : null

    if (component['class'] && !class_) return null

    const Title = class_ ? (
        <ItemTitle item={class_} />
    ) : component.title ? (
        component.title
    ) : (
        app.text('Untitled section')
    )

    const Tag = component.tag ? (
        <span className="ws-tag">{component.tag}</span>
    ) : null

    return (
        <Text className={classNames}>
            {Title} {Tag}
        </Text>
    )
})
